<template>
  <div :class="{ 'no-margin': noMargin }">
    <div v-if="mode === 'application'" :class="['tips-text-area', dataStore ? '' : 'custom-padding']" :style="styleSet">
      <div :class="{ 'tip-text-area': true }" :style="titleStyle" v-if="!isShowMode">
        <div>
          <div v-if="hyperlink" :class="{ link: true }" ref="textbox" @click="openLink()">
            <span ref="text">{{ text || displayText }}</span>
          </div>
          <div v-else :class="{ text: true }" ref="textbox">
            <span ref="text">{{ text || displayText }}</span>
          </div>
        </div>
      </div>
      <div :class="{ 'tip-text-area-display': true, active: !isShowAll }" v-if="isShowMode">
        <div>
          <div v-if="hyperlink" :class="{ link: true, padding: isShowTriangle }" ref="textbox" @click="openLink()">
            <span ref="text">{{ text || displayText }}</span>
          </div>
          <div v-else class="text" ref="textbox">
            <span class="inside" ref="text">{{ text || displayText }}</span>
          </div>
        </div>
        <div class="img-box" @click="fullDisplay" v-if="isShowTriangle">
          <img class="img" :src="triangle" alt="triangle" />
        </div>
      </div>
    </div>
    <div v-else class="tips-text-box">
      <div
        :class="{ 'tip-card': true, bottom: !isShowTriangle, 'tip-card-padding': mode !== 'expense' }"
        :style="`background: ${customStyle.background}`"
      >
        <div :class="{ content: true, active: !isShowAll }" ref="textbox">
          <span class="text-box" :style="`-webkit-line-clamp: ${maxLine}`">
            <span class="title" :style="`color: ${customStyle.titleColor}`" v-if="title.length">{{ title }}：</span>
            <span ref="text" class="text" :style="`color: ${customStyle.textColor}`" v-if="text.length">{{
              text
            }}</span>
          </span>
        </div>
        <div :class="{ 'touch-area': true, active: !isShowAll }" v-if="isShowTriangle" @click="fullDisplay">
          <div class="img-box"><img class="img" :src="triangleGray" alt="triangleGray" /></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import triangle from 'assets/images/common/triangle.png';
import triangleGray from 'assets/images/application/travel/arrow-right@3x.png';

import {NativeService} from '@/service/native/nativePluginService';

/**
 *  prop
 *  title    【mode 为 application 不生效】   提示信息 title
 *  text      即 显示内容即可                 提示信息内容
 *
 *  dataStore 是单据详情页 传给子组件的数据
 *
 *  maxLine  【mode 为 application 不生效】   最大行  超出最大行 就有 箭头  点击展开   否者没有   默认 2
 *
 *  background  要改颜色 可以 这里改  但是  arrow 默认的图片是 灰色
 */
export default {
  name: 'tip-text-area',
  props: {
    text: {
      type: String,
      default: ''
    },
    dataStore: {
      type: Object
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'application'
    },
    title: {
      type: String,
      default: ''
    },
    maxLine: {
      type: Number,
      default: 2
    },
    customStyle: {
      type: Object,
      default: () => {
        return {
          background: '#EBEDF6',
          titleColor: '#677CDA',
          textColor: '#202528'
        };
      }
    },
    hyperlink: {
      type: String,
      default: ''
    },
    titleStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    // 样式配置
    fieldConstraint: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tips: '',
      triangle,
      triangleGray,
      isShowAll: false,
      isShowTriangle: true,
      displayText: '',
      isShowMode: false
    };
  },
  computed: {
    styleSet() {
      let sizeMap = {
        L: '14px',
        M: '12px',
        S: '10px',
      };
      if (this.fieldConstraint) {
        let set = this.fieldConstraint && JSON.parse(this.fieldConstraint);
        return {
          color: set.fontColor,
          background: set.fillColor,
          fontSize: sizeMap[set.fontSize]
        };
      } else {
        return {
          fontSize: '12px'
        };
      }
    }
  },
  mounted() {
    if(this.dataStore && this.dataStore.promptInfo) {
      this.displayText = this.dataStore.promptInfo;
      this.isShowMode = true;
    } else {
      this.isShowMode = false;
    }
    this.$nextTick(() => {
      if(this.$refs.text) {
        let textheight = this.$refs.text.offsetHeight;
        let textboxHeight = this.$refs.textbox.offsetHeight;
        if(textheight-1 > textboxHeight) {             //-1 为防止 ios 设备字体多1像素 出现异常
          this.isShowTriangle = true;
        } else {
          this.isShowTriangle = false;
        }
        //
        //
      }
    });
  },
  methods: {
    fullDisplay() {
      this.isShowAll = !this.isShowAll;
    },
    openLink() {
      NativeService().openLink(res => {}, err => {}, this.hyperlink);
    },
    handlerTouchstart() {
      this.$emit('handlerTouchstart');
    },
  }
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';

.tips-text-area {
  margin: 20px 0;
  color: #8c96b4;
  font-size: px(24);
  .tip-text-area {
    position: relative;
    &.deactive {
      @include text-line(2);
      .img-box {
        .img {
          transform: rotateX(360deg);
        }
      }
    }
    .link {
      font-family: PingFangSC-Regular;
      line-height: px(34);
    }
    .text {
      font-family: PingFangSC-Regular;
      line-height: px(34);
    }
    .padding {
      padding-right: px(16);
    }
    .img-box {
      height: px(68);
      width: px(71);
      position: absolute;
      bottom: 0;
      right: 0;
      .img {
        position: absolute;
        bottom: 0;
        right: 0;
        transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
        width: px(32);
        height: px(32);
        transform: rotateX(180deg);
      }
    }
  }
  .tip-text-area-display .link {
    color: $mainColor;
    font-family: PingFangSC-Regular;
    font-size: px(24);
    line-height: px(34);
    word-break: break-all;
  }
  .tip-text-area-display {
    padding: 0 px(28);
    position: relative;

    &.active {
      .img-box {
        .img {
          transform: rotateX(360deg);
        }
      }
      .text {
        @include text-line(1);
      }
    }
    .text {
      font-family: PingFangSC-Regular;
      font-size: px(24);
      color: #8c96b4;
      line-height: px(34);
      width: 93%;
      word-break: break-word;
    }

    .img-box {
      box-shadow: inset 2px 0 0 0 #ebedef;
      height: 100%;
      width: px(64);
      position: absolute;
      bottom: 0;
      right: 0;

      .img {
        position: absolute;
        left: 50%;
        margin-left: px(-16);
        top: 50%;
        margin-top: px(-16);
        transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
        width: px(32);
        height: px(32);
        transform: rotateX(180deg);
      }
    }
  }
}
.custom-padding {
  margin: unset;
  padding: 16px 30px;
}
.no-margin {
  margin: 0;
  padding-bottom: px(30);
}
.tips-text-box {
  .text-box {
    word-break: break-word;
  }

  .tip-card-padding {
    padding: px(20) px(30) px(0) px(30);
  }

  .tip-card {
    background: #ebedf6;
    border-radius: px(8);
    font-family: PingFangSC-Regular;
    font-size: px(26);

    .touch-area {
      width: 60%;
      height: px(56);
      margin: 0 auto;
      .img-box {
        position: relative;
        left: 50%;
        top: px(8);
        margin-left: px(-12);
        width: px(24);
        height: px(24);
        .img {
          transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
          transform: rotate(270deg);
          width: px(24);
          height: px(24);
        }
      }
      &.active {
        .img-box {
          .img {
            transform: rotate(90deg);
          }
        }
      }
    }

    .content {
      .title {
        font-size: px(26);
        color: #677cda;
        line-height: px(32);
        font-weight: 600;
      }

      .text {
        font-size: px(26);
        color: #202528;
        line-height: px(32);
      }

      &.active {
        .text-box {
          @include text-line(2);
        }
      }
    }

    &.bottom {
      padding-bottom: px(20);
    }
  }
}
</style>
